import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Role } from '@/features/auth/roles';

export interface AuthUser { id: number; name: string; role: Role; schoolId: number | null; schoolName?: string; schoolCode?: string; phone?: string | null; mustChangePassword?: boolean; phoneVerified?: boolean }

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  schoolId: number | null;
  setSession: (user: AuthUser, token: string) => void;
  logout: () => void;
  patchUser: (p: Partial<AuthUser>) => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      schoolId: null,
      setSession: (user, token) => set({ user, token, schoolId: user.schoolId }),
      logout: () => set({ user: null, token: null, schoolId: null }),
      patchUser: (p) => set((st) => (st.user ? { user: { ...st.user, ...p } } : {})),
    }),
    { name: 'ojp-auth' },
  ),
);
